import { useCallback } from 'react'
import useTwinTranslation from '../../../../../../../../utils/hooks/useTwinTranslation'
import ModalSmallFilled from '../../../../../../../../baseComponents/ModalsLayouts/ModalSmallFilled'
import { twinFetchPostJSON } from '../../../../../../../../utils/globals/data'
import { ModalEditComponentProps } from '../../../../../../../../baseComponents/ModalsLayouts/types'

interface ModalEditOrderWorkingCenterProps extends ModalEditOrderWorkingCenterLogicProps {
}

const ModalEditOrderWorkingCenter: React.FC<ModalEditOrderWorkingCenterProps> = ({ ...logic }) => {
    const { t } = useTwinTranslation()
    const { confirmChangeWorkingCenter } = useModalEditOrderWorkingCenterLogic({ ...logic })

    return (
        <ModalSmallFilled translations={{
            title: t('changeWorkingCenter', 'Cambio de centro de trabajo'),
            subtitle: t('sureChangeWorkingCenterRecalculateAllWarehouses', '¿Estás seguro de cambiar el centro de trabajo? Se actualizarán todas las líneas de producto al almacén por defecto'),
            buttonAccept: t('accept', 'Aceptar'),
        }} onAccept={confirmChangeWorkingCenter} opened={true} setOpened={logic.setOpened} onClickOut={false} />
    )
}

interface ModalEditOrderWorkingCenterLogicProps extends ModalEditComponentProps {
    updateWorkingCenterURL: string
    id: number
}

const useModalEditOrderWorkingCenterLogic = ({ updateWorkingCenterURL, id, allRowData, onSubmit }: ModalEditOrderWorkingCenterLogicProps) => {
    const confirmChangeWorkingCenter = useCallback(async () => {
        const res = await twinFetchPostJSON(updateWorkingCenterURL, { id, WorkingCenterId: allRowData?.WorkingCenterId })
        await onSubmit?.(res, {})
    }, [updateWorkingCenterURL, id, allRowData?.WorkingCenterId, onSubmit])

    return { confirmChangeWorkingCenter }
}

export default ModalEditOrderWorkingCenter